import { useLocale } from "hooks";
import Image from "components/Image";
import { slugMaker } from "utils/normalizer";
import translation from "./translation";
import DateUtils from "utils/DateUtils";
import clsx from "clsx";
import Link from "next/link";
import styled from "styled-components";
import { generateImage } from "utils/newFunction";

const NewsEventCard = ({ v, className, type }) => {
  const { isFA, locale } = useLocale();
  return (
    <Link
      href={`/${type}/${v?.id}/${
        v?.metaTag?.slug || slugMaker(v?.["title"]?.value)
      }`}
      passHref
      prefetch={false}
      hrefLang={locale}
    >
      <a
        key={v?.id}
        className={clsx("tw-flex tw-flex-col tw-group", className)}
      >
        <div className="tw-aspect-[3/2] tw-relative tw-rounded-lg tw-overflow-hidden">
          <Image
            width={300}
            height={200}
            src={generateImage(v?.cover_image?.value)}
            alt={v?.imageTag?.value || v?.title?.value || ""}
            className="tw-transition-all tw-rounded-lg xxxl:tw-rounded-[10.64px] tw-w-full tw-h-full tw-object-cover"
          />
        </div>
        <span className="tw-text-[#344456] tw-text-base xxxl:tw-text-[21.27px] tw-font-bold tw-mt-4 xxxl:tw-mt-[26.7px] group-hover:tw-text-[#007FAC] tw-transition-all tw-min-h-[50px] xxxl:tw-leading-[36.07px] title">
          {v?.title?.value}
        </span>
        {v?.abstract?.value && <p className="tw-mt-1">{v?.abstract?.value}</p>}
        <p className="tw-text-[#344456]/40 tw-text-[13px] xxxl:tw-text-[17.29px] tw-mt-1 xxxl:tw-mt-[5.32px]">
          <span>{translation[locale]?.PUBLISH_DATE}: </span>
          <span>
            {isFA
              ? DateUtils.parsePersianhNewsDate(v?.publish_date?.value)
              : DateUtils.parseEnglishNewsDate(v?.publish_date?.value)}
          </span>
        </p>
      </a>
    </Link>
  );
};

const StyledNewsEventCard = styled(NewsEventCard)`
  .title {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  img {
    transition: transform 0.3s;
  }

  &:hover {
    img {
      transform: scale(1.1);
    }
  }
`;

export default StyledNewsEventCard;
